// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 *
 * @export
 * @interface CatalogSchematisation
 */
export interface CatalogSchematisation {
  /**
   *
   */
  id: number;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  updatedAt: Date;
  /**
   *
   */
  name: string;
  /**
   *
   */
  description: string | null;
  /**
   *
   */
  latestRevisionId?: number | null;
}

/**
 * Check if a given object implements the CatalogSchematisation interface.
 */
export function instanceOfCatalogSchematisation(value: object): value is CatalogSchematisation {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("updatedAt" in (value as Record<string, any>)) &&
      !("updated_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["updatedAt"] === undefined &&
      (value as Record<string, any>)["updated_at"] === undefined)
  )
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("description" in value) || value["description"] === undefined) return false;
  return true;
}

export function CatalogSchematisationFromJSON(json: any): CatalogSchematisation {
  return CatalogSchematisationFromJSONTyped(json, false);
}

export function CatalogSchematisationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CatalogSchematisation {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    updatedAt: json["updated_at"] == null ? json["updated_at"] : parseDateTime(json["updated_at"]),
    name: json["name"],
    description: json["description"],
    latestRevisionId:
      json["latest_revision_id"] === undefined
        ? undefined
        : json["latest_revision_id"] === null
        ? null
        : json["latest_revision_id"],
  };
}

export function CatalogSchematisationToJSON(json: any): CatalogSchematisation {
  return CatalogSchematisationToJSONTyped(json, false);
}

export function CatalogSchematisationToJSONTyped(
  value?: CatalogSchematisation | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    updated_at:
      value["updatedAt"] == null ? value["updatedAt"] : serializeDateTime(value["updatedAt"]),
    name: value["name"],
    description: value["description"],
    latest_revision_id: value["latestRevisionId"],
  };
}
